/// <reference path="./3dconnexionjs.d.ts" />
import type { NavlibConstructor } from './navlib.types';

/**
 * Loads 3DconnexionJS on demand, so it stays out of the editor bundle until a
 * 3D mouse driver can actually be reached.
 */
export async function loadNavlib(): Promise<NavlibConstructor> {
  const mod = (await import('@3dconnexion/3dconnexionjs')) as unknown as { _3Dconnexion: NavlibConstructor };
  return mod._3Dconnexion;
}

/** The on-screen 3D mouse used in place of the driver; see space-mouse-sim.ts. */
export async function loadSimulatedNavlib(): Promise<NavlibConstructor> {
  const { SimulatedNavlib } = await import('./space-mouse-sim');
  return SimulatedNavlib;
}

/**
 * The simulator is switched on with `?spacemouse=sim` in the URL, or, where
 * there is no address bar (the desktop app), `localStorage.spacemouse = 'sim'`.
 */
export function spaceMouseSimRequested(): boolean {
  try {
    const query = `${globalThis.location?.search ?? ''}&${globalThis.location?.hash ?? ''}`;
    if (/[?&#]spacemouse=sim\b/.test(query)) return true;
    return globalThis.localStorage?.getItem('spacemouse') === 'sim';
  } catch {
    return false;
  }
}

/**
 * The 3DxWare driver (and so the NL-Proxy) only exists on Windows and macOS;
 * anywhere else connect() could only fail with a network error in the console.
 */
export function navlibPlatformSupported(userAgent: string = globalThis.navigator?.userAgent ?? ''): boolean {
  return /Windows|Macintosh|Mac OS X/.test(userAgent);
}
